"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueJsModal = require("vue-js-modal");

var _vueJsModal2 = _interopRequireDefault(_vueJsModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.use(_vueJsModal2.default); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["edit", "item", "report"],

  data: function data() {
    return {
      text: this.item.data,
      editing: false,
      saving: false,
      toolbar: [["bold", "italic", "underline"], [{ align: [] }], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, false] }]]
    };
  },

  computed: {
    modalName: function modalName() {
      return this.item.unique + "-edit";
    }
  },

  methods: {
    editContent: function editContent() {
      this.editing = true;
      this.showModal();
    },
    showModal: function showModal() {
      this.$modal.show(this.modalName);
    },
    hideModal: function hideModal() {
      this.$modal.hide(this.modalName);
    },
    save: function save() {
      var _this = this;

      this.saving = true;

      axios.put(window.globals.prefix + "/report/" + this.report.id, {
        id: this.item.unique,
        data: this.text
      }).then(function (_ref) {
        var data = _ref.data;

        _this.saving = false;
        Event.fire("flash", {
          message: "Rapporten uppdaterades",
          level: "success"
        });
        _this.hideModal();
      }).catch(function (_ref2) {
        var response = _ref2.response;

        _this.saving = false;
        Event.fire("flash", {
          message: _.get(response, "data.error", "Something went wrong."),
          level: "error"
        });
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reports/inputs/InputField.vue
// module id = jyj+
// module chunks = 0 1